import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-resize",
  "use": "icon-resize-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-resize\"><path d=\"M0 910.222L40.277 950.5 950.5 40.277 910.222 0 0 910.222zM495.388 950.5L950.5 495.388l-40.278-40.277-455.11 455.111 40.276 40.278z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol